export default {
  title: 'Bạn có thể đóng trang này. Nếu có bất kỳ câu hỏi nào, xin vui lòng gọi cho chúng tôi theo số',
  'call-rating': 'Đánh giá cuộc gọi',
  comment: {
    title: 'Vui lòng để lại nhận xét của bạn:',
    placeholder: 'Viết ra nếu bạn hài lòng, mong đợi và ấn tượng của bạn',
    error: 'Nếu bạn đánh giá thấp, vui lòng giải thích lý do?',
    'send-btn': 'Gửi',
  },
  'accepted-message': 'Phản hồi của bạn đã được chấp nhận. Cảm ơn bạn đã sử dụng dịch vụ giao hàng của chúng tôi!',
  'rate-thanks': 'Cảm ơn phản hồi của bạn!',
  'rate-prompt': 'Hãy đánh giá cuộc gọi của chúng tôi!',
}
